export const SHOW_MESSAGE = "show_message";
export const HIDE_MESSAGE = "hide_message";
export const HIDE_HEADER_FOOTER = "HIDE_HEADER_FOOTER";

// user
export const SET_CHECK_USER_INFO = "SET_CHECK_USER_INFO";
export const SHOW_REGISTER = "SHOW_REGISTER";
export const REGISTER_CURRENT_STEP = "REGISTER_CURRENT_STEP";
export const LOADING_REGISTER = "LOADING_REGISTER";
export const GET_ME = "get_me";
export const SET_CURRENT_USER = "set_current_user";
export const SET_SHOW_OTP = "set_show_otp";
export const SET_AUTH_TOKEN = "set_auth_token";
export const LOADING_UPDATE_USER_PASS = "laoding_update_user_pass";
export const SET_USER_PROFILE_IMGAE = "set_user_profile_image";
export const LOADING_UPDATE_USER = "loading_update_user";
export const SET_USER_SCORE = "set_user_score";
export const SET_LOADING_LOGOUT = "set_loading_logout";
export const SET_RESETPASS_NATIONALCODE = "set_resetpass_nationalCode";
export const SET_SHOW_NATIONALCODE_DIALOG = "set_show_nationalCode_dialog";
export const SET_NATIONAL_CODE_OTP = "set_national_code_otp";
export const SET_USER_LEVEL = "set_user_level";
export const SET_MAX_SCORE = "set_max_score";
export const SET_MIN_SCORE = "set_min_score";
export const SOUND_MUTED = "sound_muted";
export const SET_USER_POINT = "set_user_point";

// quiz
export const SET_QUIZ_ID = "set_quiz_id";
export const SET_QUIZ = "set_quiz";
export const SET_QUIZ_DURATION = "set_quiz_duration";
export const SET_ALL_QUESTIONS = "set_all_questions";
export const SET_EASY_QUESTIONS = "set_easy_quesions";
export const SET_MEDIUM_QUESITONS = "set_medium_questions";
export const SET_HARD_QUESTIONS = "set_hard_quesitons";
export const SET_TECKET = "set_ticket";
export const SET_DURATION = "set_duration";
export const LOADING_FETCH_LB_DATA = "LOADING_FETCH_LB_DATA";
export const SET_LEADER_BOARD_DATA = "set_leader_board_data";
export const ANSWERED_QUESTIONS_COUNT = "answered_questions_count";
export const SET_MAX_ANSWER = "set_max_answer";
export const SET_QUESTION_NOT_ANSWERED = "set_question_not_answered";
export const LAST_QUESTION_ID = "last_question_id";
export const RENDER_LOADING = "render_loading";
export const FINALIZE_QUIZ = "finalize_quiz";
export const SET_FINALIZE_REPORT = "set_finalize_report";

export const LOADING_QUIZ_REQUESTS = "loading_quiz_requests";
export const SET_QUESTION_DATA = "SET_QUESTION_DATA";
export const QUESTION_ANSWER = "QUESTION_ANSWER";
export const SUGGESTED_USER_DATA = "SUGGESTED_USER_DATA";
export const QUESTION_ANSWERED = "QUESTION_ANSWERED";
export const SHOW_FINALIZE_MODAL = "SHOW_FINALIZE_MODAL";
export const SHOW_CHEAT_MODAL = "SHOW_CHEAT_MODAL";
export const SET_WRONG_ANSWERS = "SET_WRONG_ANSWERS";
export const SET_RIGHT_ANSWER = "SET_RIGHT_ANSWER";

export const SET_SHOW_WORD_GAME_HINT_MODAL = "SET_SHOW_WORD_GAME_HINT_MODAL";

// blog
export const SET_BLOGS = "SET_BLOGS";
export const SET_RB_BLOGS = "SET_RB_BLOGS";
export const CLEAR_RB_BLOGS = "CLEAR_RB_BLOGS";
export const BLOG_TOTAL_PAGES = "BLOG_TOTAL_PAGES";
export const FETCH_BLOG_LOADING = "FETCH_BLOG_LOADING";
export const SET_BLOG_FILTER = "SET_BLOG_FILTER";
export const NEW_BLOG = "NEW_BLOG";
export const LOADING_GET_BLOG_ITEMS = "LOADING_GET_BLOG_ITEMS";

export const SET_GALLERY_MEDIA = "SET_GALLERY_MEDIA";
export const SET_GALLERY_TOTAL_PAGES = "SET_GALLERY_TOTAL_PAGES";
